module.exports = __webpack_public_path__ + "static/media/privacy_more-privacy.b54d6710.svg";